<template>
    <div class="text-left">
        <div class="px-3 py-2 text-xs font-bold text-slate-400 uppercase tracking-wider">{{ $t('menu') }}</div>
        <nav class="space-y-1 mt-1 text-sm font-medium">
            <div v-for="item in footer" :key="item.name">
                <div v-if="!item.children" class="flex items-center justify-between px-3 py-2.5 rounded-xl transition cursor-pointer"
                    :class="isActive(item) ? 'bg-sky-50 text-sky-700 font-semibold' : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'"
                    @click="go(item.path)">
                    <span class="flex items-center gap-3">
                        <component :is="iconFor(item.name)" class="w-4 h-4" :class="isActive(item) ? 'text-sky-600' : 'text-slate-400'" />
                        {{ $t(item.name) }}
                    </span>
                    <span v-if="isActive(item)" class="w-1.5 h-1.5 rounded-full bg-sky-600"></span>
                </div>
                <div v-else>
                    <div class="flex items-center gap-3 px-3 py-2.5 rounded-xl transition cursor-pointer"
                        :class="isActive(item) ? 'bg-sky-50 text-sky-700 font-semibold' : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'"
                        v-b-toggle="'collapse-' + item.name + '-' + uid">
                        <component :is="iconFor(item.name)" class="w-4 h-4" :class="isActive(item) ? 'text-sky-600' : 'text-slate-400'" />
                        <span class="flex-grow-1">{{ $t(item.name) }}</span>
                        <svg class="w-3.5 h-3.5 opacity-60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path d="M19 9l-7 7-7-7" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                        </svg>
                    </div>
                    <b-collapse :id="'collapse-' + item.name + '-' + uid" :visible="isActive(item)">
                        <div class="pl-11 pr-3 py-1 space-y-1">
                            <p v-for="child in item.children" :key="child.name"
                                class="text-sm font-medium py-1.5 cursor-pointer m-0"
                                :class="$route.path === child.path ? 'text-sky-700 font-semibold' : 'text-slate-500 hover:text-slate-800'"
                                @click="go(child.path)">
                                {{ $t(child.name) }}
                            </p>
                        </div>
                    </b-collapse>
                </div>
            </div>
        </nav>

        <div class="mt-6 p-4 rounded-xl bg-gradient-to-br from-sky-900 to-slate-900 text-white relative overflow-hidden">
            <div class="absolute -right-4 -bottom-4 w-20 h-20 bg-teal-500/20 rounded-full blur-xl"></div>
            <p class="text-xs text-teal-300 font-medium mb-0">MetaTrader 5</p>
            <p class="text-sm font-bold mt-1 mb-0">{{ $t('mt5_title') }}</p>
            <p class="text-[11px] text-slate-300 mt-1 mb-0">{{ $t('mt5_content') }}</p>
            <button type="button"
                class="mt-3 w-100 py-1.5 text-xs font-semibold bg-white/10 hover:bg-white/20 rounded-lg text-white transition border border-white/10"
                @click="go('/web/home/dashboard')">
                {{ $t('mt5_terminal') }}
            </button>
        </div>

        <div class="logout-btn mt-4 d-md-none">
            <div class="text-12">{{ $t('any_enquiries') }}</div>
            <div class="d-flex" @click="logout">
                <img src="../assets/images/actions/logout2.png" alt="" height="24px" width="24px">
                <p class="ml-3">{{ $t('logout') }}</p>
            </div>
        </div>
    </div>
</template>
<script>
const IconDashboard = {
    render(h) {
        return h('svg', { attrs: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor' } }, [
            h('path', { attrs: { d: 'M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2' } }),
        ]);
    }
};
const IconUser = {
    render(h) {
        return h('svg', { attrs: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor' } }, [
            h('path', { attrs: { d: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2' } }),
        ]);
    }
};
const IconNetwork = {
    render(h) {
        return h('svg', { attrs: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor' } }, [
            h('path', { attrs: { d: 'M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2' } }),
        ]);
    }
};
const IconReport = {
    render(h) {
        return h('svg', { attrs: { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor' } }, [
            h('path', { attrs: { d: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2' } }),
        ]);
    }
};
const ICONS = {
    dashboard: IconDashboard,
    accounts: IconUser,
    profile: IconUser,
    network: IconNetwork,
    report: IconReport,
};
export default {
    props: ['footer'],
    computed: {
        uid() {
            return this._uid;
        }
    },
    methods: {
        iconFor(name) {
            return ICONS[name] || IconDashboard;
        },
        go(path) {
            this.$router.push(path);
        },
        logout() {
            localStorage.removeItem('currencyToken');
            this.$router.push('/web/sessions/login');
        },
        isActive(item) {
            return this.$route.path.startsWith(item.path) || (item.children && item.children.some(jtem => this.$route.path.startsWith(jtem.path)));
        },
    }
}
</script>
